import "core-js/modules/es.array.find-index.js";
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "home-guan"
};
var _hoisted_2 = {
  class: "tab"
};
var _hoisted_3 = {
  class: "guan-content"
};
import { ChevronRightDoubleIcon } from 'tdesign-icons-vue-next';
import { ref, computed, onMounted, onUnmounted } from 'vue';
import NavTab from '../Components/NavTab.vue';
import Board from './Board/index.vue';
import Result from './Result/index.vue';
import Report from './Report/index.vue';
import { env_name } from '@/util/util.js';
import WujieVue from 'wujie-vue3';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var bus = WujieVue.bus;
    var tabs = [{
      name: '角色看板',
      value: 1,
      component: Board,
      exist: true
    }, {
      name: '成绩管理',
      value: 2,
      component: Result,
      exist: true
    }, {
      name: '课堂报告',
      value: 3,
      component: Report,
      exist: true
    }];
    var defaultIndex = ref(1);
    var currentComponent = computed(function () {
      var index = tabs.findIndex(function (item) {
        return item.value === defaultIndex.value;
      });
      return tabs[index].component;
    });
    var handleChangeTab = function handleChangeTab(item) {
      defaultIndex.value = item.value;
    };

    // 查看更多
    var toClassReport = function toClassReport() {
      var commonName = env_name ? "//".concat(env_name, "web.zhixuehuijiao.cn") : '//web.zhixuehuijiao.cn';
      window.open("".concat(commonName, "/classReports?classReports=%2Freport"));
    };

    // 角色看板应用入口
    var roRoleBoard = function roRoleBoard() {
      var commonName = env_name ? "//".concat(env_name, "web.zhixuehuijiao.cn") : '//web.zhixuehuijiao.cn';
      window.open("".concat(commonName, "/dataView?dataView=%2Fsub-data-view-svc%2FinteractiveData"));
    };
    var showAppbtn = ref(false);
    var showDataView = ref(false);
    onMounted(function () {
      bus.$on('show-enter-class-report', function (val) {
        showAppbtn.value = val;
      });
      bus.$on('show-enter-data-view', function (val) {
        showDataView.value = val;
      });
    });
    onUnmounted(function () {
      bus.$off('show-enter-class-report');
      bus.$off('show-enter-data-view');
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(NavTab, {
        tabs: tabs,
        "default-index": defaultIndex.value,
        onChange: handleChangeTab
      }, null, 8, ["default-index"]), showDataView.value && defaultIndex.value === 1 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "look-more",
        onClick: roRoleBoard
      }, [_cache[0] || (_cache[0] = _createTextVNode(" 应用入口 ", -1)), _createVNode(_unref(ChevronRightDoubleIcon))])) : _createCommentVNode("", true), showAppbtn.value && defaultIndex.value === 3 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "look-more",
        onClick: toClassReport
      }, [_cache[1] || (_cache[1] = _createTextVNode(" 进入应用 ", -1)), _createVNode(_unref(ChevronRightDoubleIcon))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createBlock(_resolveDynamicComponent(currentComponent.value)))])]);
    };
  }
};